class Brush {
    constructor() {
        this.originX = 0
    }

    setData(container, initialPosition, containerBox) {
        this.container = container;
        this.containerHeight = containerBox.height;
        this.brushSize = {
            x: initialPosition,
            width: .1
        }
    }

    create() {
        this.brush = this.container
            .append("rect")
            .attr("class", "brush")
            .attr("x", this.brushSize.x)
            .attr("y", 0)
            .attr("height", this.containerHeight)
            .attr("width", this.brushSize.width)

        this.brushFirstEdge = this.container
            .append("line")
            .attr("class", "firstEdge")
            .attr("x1", this.brushSize.x)
            .attr("y1", 0)
            .attr("x2", this.brushSize.x)
            .attr("y2", this.containerHeight)

        this.brushSecondEdge = this.container
            .append("line")
            .attr("class", "secondEdge")
            .attr("x1", this.brushSize.x)
            .attr("y1", 0)
            .attr("x2", this.brushSize.x)
            .attr("y2", this.containerHeight)

        return [this.brush, this.brushFirstEdge, this.brushSecondEdge]
    }

    onCreateBrush(dragEvent, scroll = 0) {
        if (dragEvent.type === "start") {
            this.startX = dragEvent.x
            this.brushSize.x = this.startX
            this.brushSize.width = .1
        } else if (dragEvent.type === "drag") {
            if (dragEvent.x > this.startX) {
                this.brushSize.x = this.startX
                this.brushSize.width = dragEvent.x - this.brushSize.x
            } else {
                this.brushSize.x = dragEvent.x;
                this.brushSize.width = this.startX - dragEvent.x
            }
        }
        this.brushSize.width < 0 ? .1 : this.brushSize.width;
        this.draw()
    }

    draw() {
        this.brush
            .attr("x", this.brushSize.x)
            .attr("width", this.brushSize.width)
            .attr("height", this.containerHeight)

        this.brushFirstEdge
            .attr("x1", this.brushSize.x)
            .attr("x2", this.brushSize.x)
            .attr("y2", this.containerHeight)

        this.brushSecondEdge
            .attr("x1", this.brushSize.x + this.brushSize.width)
            .attr("x2", this.brushSize.x + this.brushSize.width)
            .attr("y2", this.containerHeight)
    }

    updateOnDrag(dragEvent) {
        if (dragEvent.type === "start") {
            this.currentX = dragEvent.x
            this.offsetDragX = dragEvent.x - this.brushSize.x
        } else if (dragEvent.type === "drag") {
            this.brushSize.x = dragEvent.x - this.offsetDragX
        }
        this.draw();
    }

    updateOnDragEdges(dragEvent, selector, scroll = 0) {
        if (dragEvent.type === "start") {
            this.currentX1 = this.brushSize.x;
            this.currentX2 = this.brushSize.x + this.brushSize.width;
        } else if (dragEvent.type === "drag") {
            if (selector.attr('class') === "secondEdge") {
                if (dragEvent.x < this.currentX1) {
                    this.currentX1 += scroll
                    this.brushSize.x = dragEvent.x + scroll;
                    this.brushSize.width = this.currentX1 - dragEvent.x;
                } else {
                    this.brushSize.x += scroll;
                    this.brushSize.width = dragEvent.x - this.brushSize.x
                }
            } else {
                if (dragEvent.x > this.currentX2) {

                    this.currentX1 = this.currentX2;
                    this.brushSize.width = dragEvent.x - this.currentX1;

                    if (scroll) {
                        this.brushSize.x += scroll;
                        this.currentX2 += scroll;
                    }
                } else {
                    this.currentX2 += scroll
                    this.brushSize.x = dragEvent.x
                    this.brushSize.width = this.currentX2 - dragEvent.x

                }
            }
        }

        this.brushSize.width < 0 ? 1 : this.brushSize.width;

        this.draw()
    }

    getParameters() {
        return this.brushSize;
    }

    getOffsetDragX(event) {
        return Math.abs(this.currentX - event.x);
    }

    setParameters(newParameters) {
        this.brushSize = newParameters
        this.draw()
    }

    setUp(newBrushHeight) {
        this.containerHeight = newBrushHeight;

        this.draw();
    }

    hide() {
        this.brush.style("opacity", "0")
        this.brushFirstEdge.style("opacity", "0")
        this.brushSecondEdge.style("opacity", "0")
    }

    show() {
        this.brush.style("opacity", ".5")
        this.brushFirstEdge.style("opacity", ".5")
        this.brushSecondEdge.style("opacity", ".5")
    }

    selected() {
        this.brush.style("opacity", ".3")
    }

    deselected() {
        this.brush.style("opacity", ".5")
    }

    get() {
        return this.brush;
    }
}

export default Brush;